export class Calendar {
  constructor(difference) {
    this.styleId = 1
    this.width = 600
    this.height = 550
    this.top = 20
    this.left = 20
    this.innerElement = "cxCalendar"
    this.color = "rgba(0,0,0,1)"
    this.textIsThemeColor = false
    this.background = []
    this.bgColor = "rgb(255, 255, 255)"
    this.imgSrc = ""
    this.bgType = "自定义"
    this.bgColorIsThemeColor = false
    this.opacity = 100
    this.borderTypeFlag = 2 //圆角的类型 分为1四个角可以单独设置 2四个角一致
    this.borderRadius = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderColor = "#E9E9E9"
    this.borderWidth = 1
    this.borderStyle = "solid" // solid, dashed, dotted
    this.borderIsThemeColor = false
    this.boxShadowColor = []
    this.boxShadowH = []
    this.boxShadowV = []
    this.boxShadowBlur = []
    this.boxShadowSpread = []
    this.paddingTypeFlag = 1
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0
    this.showTitle = true
    this.dateStyle = "1"
    this.titleFontFamily = "sans-serif"
    this.titleFontSize = 20
    this.titleFontWeight = 400
    this.titleFontStyle = "normal"
    this.titleTextDecoration = "none"
    this.titleLineHeight = 40
    this.titleLineHeightType = "px"
    this.titleLetterSpacing = 0
    this.titleWritingMode = "horizontal-tb"
    this.titleTextAlign = "center"
    this.titleTextIsThemeColor = false
    this.titleColor = "rgb(255,255,255)"
    this.fontFamily = "sans-serif"
    this.fontSize = 16
    this.fontWeight = 400
    this.fontStyle = "normal"
    this.textDecoration = "none"
    this.lineHeight = 40
    this.letterSpacing = 0
    this.writingMode = "horizontal-tb"
    this.textAlign = "center"
    this.textIsThemeColor = false
    this.titleBgColorIsThemeColor = true
    this.titleBgColor = "rgb(255, 255, 255)"
    this.titlePaddingTypeFlag = 1
    this.titlePadding = 0
    this.titlePaddingTop = 0
    this.titlePaddingRight = 0
    this.titlePaddingBottom = 0
    this.titlePaddingLeft = 0
    this.showLunar = true
    this.firstDayOfWeek = 1
    this.weekColor = "rgba(0,0,0,0.6)"
    this.weekFontFamily = "sans-serif"
    this.weekFontSize = 14
    this.weekFontWeight = 400
    this.weekBgColorIsThemeColor = false
    this.weekBgColor = "rgb(255,255,255)"
    this.lunarColor = "#B3B3B3"
    this.lunarFontFamily = "sans-serif"
    this.lunarFontSize = 12
    this.lunarFontWeight = 400
    this.lunarHoverColor = "#B3B3B3"
    this.lunarHoverFontFamily = "sans-serif"
    this.lunarHoverFontSize = 12
    this.lunarHoverFontWeight = 400
    this.showNotCurrentDate = true
    this.notCurrentTextIsThemeColor = false
    this.notCurrentTextColor = "rgba(0, 0, 0, 0.2)"
    this.hoverColor = "rgba(0,0,0,0.6)"
    this.hoverFontFamily = "sans-serif"
    this.hoverFontSize = 14
    this.hoverFontWeight = 400
    this.hoverBorderTypeFlag = 2
    this.hoverBorderRadius = 20
    this.hoverBorderTopLeftRadius = 20
    this.hoverBorderTopRightRadius = 20
    this.hoverBorderBottomRightRadius = 20
    this.hoverBorderBottomLeftRadius = 20
    this.hoverBgColorIsThemeColor = false
    this.hoverBgColor = "rgba(43, 103, 255, 0.16)"
    this.hoverBorderIsThemeColor = false
    this.hoverBorderColor = "rgba(43, 103, 255, 0.16)"
    this.hoverBorderStyle = "solid" // solid, dashed, dotted
    this.hoverBorderWidth = 1
    this.showHoverBorder = true

    this.activeColor = "rgba(0,0,0,0.6)"
    this.activeFontFamily = "sans-serif"
    this.activeFontSize = 14
    this.activeFontWeight = 400
    this.activeBorderTypeFlag = 2
    this.activeBorderRadius = 20
    this.activeBorderTopLeftRadius = 20
    this.activeBorderTopRightRadius = 20
    this.activeBorderBottomRightRadius = 20
    this.activeBorderBottomLeftRadius = 20
    this.activeBgColorIsThemeColor = false
    this.activeBgColor = "rgba(0,0,0,0)"
    this.activeBorderIsThemeColor = false
    this.activeBorderColor = "#3D82F2"
    this.activeBorderStyle = "solid" // solid, dashed, dotted
    this.activeBorderWidth = 1
    this.showActiveBorder = true

    this.datePaddingTopVal = 0
    this.datePaddingBottomVal = 0

    this.showTodayStyle = true
    this.todayStyleColor = "rgba(0,0,0,0.6)"
    this.todayStyleFontFamily = "sans-serif"
    this.todayStyleFontSize = 14
    this.todayStyleFontWeight = 400
    this.todayStyleBorderTypeFlag = 2
    this.todayStyleBorderRadius = 20
    this.todayStyleBorderTopLeftRadius = 20
    this.todayStyleBorderTopRightRadius = 20
    this.todayStyleBorderBottomRightRadius = 20
    this.todayStyleBorderBottomLeftRadius = 20
    this.todayStyleBorderIsThemeColor = false
    this.todayStyleBorderColor = "#3D82F2"
    this.todayStyleBorderStyle = "solid" // solid, dashed, dotted
    this.todayStyleBorderWidth = 1
    this.todayStyleBgColorIsThemeColor = false
    this.todayStyleBgColor = "rgba(0,0,0,0)"
    this.showTodayStyleBorder = true

    this.showActivityMark = true
    this.activityWidth = 4
    this.activityColorIsThemeColor = true
    this.activityColor = "#3D82F2"

    this.showButton = true
    this.iconSrc = "FCDE54BF21DDAE3D"
    this.buttonIconType = "icon" // img,icon 图片和字体图标
    this.iconColorIsThemeColor = false
    this.buttonIconColor = "rgb(255,255,255)"
    this.iconResInfo = {}
    this.buttonIconSize = 14
    this.iconBgIsThemeColor = false
    this.buttonIconBackgroundColor = "rgba(255,255,255,0)"
    this.buttonIconBackgroundWidth = 30
    this.buttonIconBackgroundHeight = 30
    this.buttonIconBackGroundBorderRadius = 0
    this.buttonBoxShadowH = []
    this.buttonBoxShadowV = []
    this.buttonBoxShadowBlur = []
    this.buttonBoxShadowSpread = []
    this.buttonBoxShadowColor = []
    this.buttonIconCustomTop = false
    this.buttonIconPadding = 20
    this.buttonIconTop = 20
    this.leftButtonIconX = 0
    this.leftButtonIconY = 0
    this.rightButtonIconX = 0
    this.rightButtonIconY = 0

    this.legendPosition = "0"
    this.showTodayLegend = true
    this.todayLegendVal = "今日"
    this.todayLegendColor = "rgba(0,0,0,0.6)"
    this.todayLegendFontFamily = "sans-serif"
    this.todayLegendFontSize = 14
    this.todayLegendFontWeight = 400
    this.todayLegendBorderWidth = 1
    this.todayLegendBorderIsThemeColor = false
    this.todayLegendBorderColor = "#3D82F2"
    this.todayLegendBgColor = "rgba(255,255,255,0)"
    this.todayLegendBgType = 1
    this.todayLegendShapeType = "round" // rectangle，radius， round
    this.todayLegendBorderRadius = 0
    this.todayLegendWidth = 12
    this.todayLegendHeight = 12

    this.showActivityLegend = true
    this.activityLegendVal = "当日有活动安排"
    this.activityLegendColor = "rgba(0,0,0,0.6)"
    this.activityLegendFontFamily = "sans-serif"
    this.activityLegendFontSize = 14
    this.activityLegendFontWeight = 400
    this.activityLegendBorderWidth = 1
    this.activityLegendBorderIsThemeColor = false
    this.activityLegendBorderColor = "#3D82F2"
    this.activityLegendBgColor = "#3D82F2"
    this.activityLegendBgType = 0
    this.activityLegendShapeType = "round" // rectangle，radius， round
    this.activityLegendBorderRadius = 0
    this.activityLegendWidth = 12
    this.activityLegendHeight = 12
    this.legendSpace = 24
    this.legendPaddingTypeFlag = 2
    this.legendPadding = 0
    this.legendPaddingTop = 0
    this.legendPaddingRight = 0
    this.legendPaddingBottom = 0
    this.legendPaddingLeft = 0
    this.selectedDates = []
    this.relativeComponentId = ''
    this.startDateFlag = ''
    this.endDateFlag = ''

    this.pickDate = ""

    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
